<template>
  <div class="search-content">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'ExameCenterLayout',
    data () {
      return {
        tabs: {
          items: [
            {
              key: '1',
              title: '考级中心考级点'
            },
            {
              key: '3',
              title: '数据统计'
            },
            // {
            //   key: '2',
            //   title: '话题管理'
            // },
            /*
            {
              key: '2',
              title: '考级申报'
            },
            {
              key: '3',
              title: '考官管理'
            },
            {
              key: '4',
              title: '考级人员管理'
            },
            {
              key: '5',
              title: '考官人员管理'
            },
            {
              key: '6',
              title: '监督人员管理'
            }*/
          ],
          active: () => {
            switch (this.$route.path) {
              case '/qcxj/ExameCenterList':
                return '1'
              case '/qcxj/QcxjTopicList':
                return '2'
              case '/qcxj/DataMap':
                return '3'
              // case '/qcxj/KaoguanList':
              //   return '3'
              case '/qcxj/KaojiMemberList':
                return '4'
              case '/qcxj/KaoguanMemberList':
                return '5'
              case '/qcxj/JianduMemberList':
                return '6'
              default:
                return '1'
            }
          },
          callback: (key) => {
            switch (key) {
              case '1':
                this.$router.push('/qcxj/ExameCenterList')
                break
              case '2':
                this.$router.push('/qcxj/QcxjTopicList')
                break
              case '3':
                this.$router.push('/qcxj/DataMap')
                // this.$router.push('/qcxj/KaoguanList')
                break
              case '4':
                this.$router.push('/qcxj/KaojiMemberList')
                break
              case '5':
                this.$router.push('/qcxj/KaoguanMemberList')
                break
              case '6':
                this.$router.push('/qcxj/JianduMemberList')
                break
              default:
                this.$router.push('/workplace')
            }
          }
        },
        search: false
      }
    },
    computed: {

    },
    methods: {
    }
  }
</script>

<style lang="less" scoped>
  .search-head{
    background-color: #fff;
    margin: -25px -24px -24px;
    .search-input{
      text-align: center;
      margin-bottom: 16px;
    }
  }
  .search-content{
    margin-top: 0px;
  }
</style>
